'use strict';
const Notification = require('../index');

module.exports = Notification.extend({
    defaults: {
        sender: null,
        project: null,
        message: null,
        eventAt: null,
        version: 2
    },

    getActionName() {
        return this.get('message').action.name;
    },

    getCommentID() {
        return this.get('message').comment.id;
    },

    getProjectName() {
        return this.get('project').name;
    },

    getProjectID() {
        return this.get('project').id;
    },

    getActionID() {
        return this.get('message').action.id;
    },

    getTitle: function() {
        return this.getActionName();
    },

    getIconClass: function() {
        return 'fa fa-list text-primary';
    },

    getSender: function() {
        return this.get('sender');
    },

    getSubTitle: function() {
        return `in ${this.getProjectName()}`;
    },

    getContent: function() {
        return this.get('message').comment.body;
    },

    getLinkURL: function() {
        return `/projects/${this.getProjectID()}/processes/${this.getActionID()}#/comments/${this.getCommentID()}`
    }
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/actionwork/index.js